// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldResetButton_root__3qLDN","iconClose":"FieldResetButton_iconClose__2BxA2"};